import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { ADPComponentsModule } from 'digital-core';

@Component({
  selector: 'app-adp-label-dynamic',
  imports: [ADPComponentsModule],
  templateUrl: './adp-label-dynamic.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AdpLabelDynamicComponent {
  readonly labelKey = input.required<string>();
  readonly context = input<Record<string, unknown> | null>(null);

  // Force <adp-label> to re-mount whenever the context object changes,
  // because the digital-core component interpolates {placeholders} into
  // its internal string once and never re-reads the raw resource.
  protected readonly renderToken = computed(() => JSON.stringify(this.context()));
}
